import { CommonModule, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateStore } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { SliderModule } from 'primeng/slider';
import { AuditInterceptorService } from './services/audit-interceptor/audit-interceptor.service';

import { LoaderService } from './components/loader/loader.service';
import { CommonService } from './services/common.service';
import { HttpService } from './services/http.service';

import { LoaderComponent } from './components/loader/loader.component';
import { NotificationComponent } from './components/notification/notification.component';
import { TextInputComponent } from './components/text-input/text-input.component';

import { ModalComponent } from './components/modal/modal.component';

import { AmountInputComponent } from './components/amount-input/amount-input.component';
import { AmountInputService } from './components/amount-input/amount-input.service';
import { AmountCurrencyPipe } from './components/amount-input/currency.pipe';
import { ParseDecimalsDirective } from './components/amount-input/parse-decimals.directive';
import { SliderAmountInputComponent } from './components/slider-amount-input/slider-amount-input.component';
import { SliderAmountInputService } from './components/slider-amount-input/slider-amount-input.service';
import { SliderCurrencyPipe } from './components/slider-amount-input/slider-currency.pipe';
import { SliderParseDecimalsDirective } from './components/slider-amount-input/slider-parse-decimals.directive';

import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from './components/modal/confirmation.service';
import { ModalService } from './components/modal/modal.service';
import { GenerateTokenService } from './services/generate-token/generate-token.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    SliderModule,
    TranslateModule,
    ToastModule,
  ],
  exports: [
    TextInputComponent,
    LoaderComponent,
    NotificationComponent,
    ModalComponent,
    TranslateModule,
    AmountInputComponent,
    SliderAmountInputComponent,
  ],
  declarations: [
    TextInputComponent,
    LoaderComponent,
    NotificationComponent,
    ModalComponent,
    AmountInputComponent,
    SliderAmountInputComponent,
    ParseDecimalsDirective,
    SliderParseDecimalsDirective,
    AmountCurrencyPipe,
    SliderCurrencyPipe,
  ],
  providers: [
    CommonService,
    LoaderService,
    TranslateStore,
    ModalService,
    ConfirmationService,
    DecimalPipe,
    AmountCurrencyPipe,
    SliderCurrencyPipe,
    AmountInputService,
    SliderAmountInputService,
    MessageService,
    GenerateTokenService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuditInterceptorService, multi: true },
  ],
})
export class VassCoreModule {}
